import type { ExerciseQueueItem } from 'api/rest/exerciseQueues/exerciseQueues.types';

export const getQueueItemStatusLabel = (item: ExerciseQueueItem): string => {
  if (!item.answered) {
    return 'Pominięte';
  }
  if (item.correct === true) {
    return 'Poprawna';
  }
  if (item.correct === false) {
    return 'Błędna';
  }
  return 'Rozwiązane';
};
